import { createContext } from 'react';
import { Optional } from '../Common/interfaces';

export type ValidationColors = {
    backgroundColor: string;
    borderColor: string;
    outlineColor: string;
    textColor: string;
};
export type ValidationStatus = 'success' | 'error';
type Props = {
    validationStatus?: ValidationStatus;
    validationColors?: Optional<ValidationColors>;
};
export const FormContext = createContext<Props>({});

export function getColorsForStatus(
    status: Optional<ValidationStatus>,
): ValidationColors | null {
    switch (status) {
        case 'error':
            return {
                backgroundColor: 'bg-secondary-error',
                borderColor: 'border-secondary-error',
                outlineColor: 'outline-secondary-error',
                textColor: 'text-secondary-error',
            };
        case 'success':
            return {
                backgroundColor: 'bg-success',
                borderColor: 'border-success',
                outlineColor: 'outline-success',
                textColor: 'text-success',
            };
        case null:
        case undefined:
            return null;
    }
}
